import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
export const ConfettiAnimation = ({ trigger, x = 0, y = 0 }) => {
    const [particles, setParticles] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const colors = [
        '#FFD700', // Gold
        '#FF6B6B', // Red
        '#4ECDC4', // Teal
        '#45B7D1', // Blue
        '#FFA07A', // Salmon
        '#98D8C8', // Mint
        '#F7DC6F', // Yellow
        '#BB8FCE', // Purple
        '#85C1E2', // Light Blue
        '#F8B88B', // Orange
    ];
    useEffect(() => {
        if (trigger) {
            // Generate confetti particles
            const newParticles = Array.from({ length: 50 }, (_, i) => ({
                id: i,
                left: Math.random() * 100 - 50, // Random x offset from trigger point
                top: Math.random() * 100 - 50, // Random y offset from trigger point
                delay: Math.random() * 0.1,
                duration: 2 + Math.random() * 0.5,
                size: 8 + Math.random() * 12,
                color: colors[Math.floor(Math.random() * colors.length)],
                rotation: Math.random() * 360,
            }));
            setParticles(newParticles);
            setIsVisible(true);
            // Hide after animation completes
            const timer = setTimeout(() => {
                setIsVisible(false);
                setParticles([]);
            }, 2800);
            return () => clearTimeout(timer);
        }
    }, [trigger]);
    if (!isVisible || particles.length === 0) {
        return null;
    }
    return (_jsxs("div", { className: "fixed inset-0 pointer-events-none overflow-hidden", children: [particles.map((particle) => (_jsx("div", { className: "absolute animate-pulse", style: {
                    left: `${50 + particle.left}%`,
                    top: `${50 + particle.top}%`,
                    animation: `confetti-fall ${particle.duration}s linear ${particle.delay}s forwards`,
                    width: `${particle.size}px`,
                    height: `${particle.size}px`,
                    opacity: 0,
                }, children: _jsx("div", { style: {
                        width: '100%',
                        height: '100%',
                        backgroundColor: particle.color,
                        borderRadius: Math.random() > 0.5 ? '50%' : '0',
                        transform: `rotate(${particle.rotation}deg)`,
                        boxShadow: `0 0 10px ${particle.color}80`,
                    } }) }, particle.id))), _jsx("style", { children: `
        @keyframes confetti-fall {
          0% {
            opacity: 1;
            transform: translateY(0) translateX(0) rotateZ(0deg);
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform: translateY(600px) translateX(${Math.random() * 200 - 100}px) rotateZ(720deg);
          }
        }
      ` })] }));
};
